module.exports = __webpack_public_path__ + "img/house-3@3x.7b89f7e4.jpg";